import { useState } from 'react'
import { message } from 'antd'
import { submitAIRecommendationFeedback } from '../../../api/assessmentReview'
import { EXERCISE_QUESTIONS, NUTRITION_QUESTIONS, SLEEP_QUESTIONS, HOLISTIC_QUESTIONS, RECOMMENDATIONS_QUESTIONS, NEXT_STEPS_QUESTIONS } from '../../../utils/constant'

const getFeedbackQuestions = (type) => {
  switch(type) {
    case 'exercise': return EXERCISE_QUESTIONS
    case 'nutrition': return NUTRITION_QUESTIONS
    case 'sleep': return SLEEP_QUESTIONS
    case 'holistic recommendations': return HOLISTIC_QUESTIONS
    case 'what to expect': return RECOMMENDATIONS_QUESTIONS
    case 'next steps': return NEXT_STEPS_QUESTIONS
    default: return EXERCISE_QUESTIONS
  }
}

export const useFeedbackModal = (person, arDetail) => {
  const [showFeedbackModal, setShowFeedbackModal] = useState(false)
  const [currentFeedbackType, setCurrentFeedbackType] = useState(null)
  const [feedbackQuestions, setFeedbackQuestions] = useState(EXERCISE_QUESTIONS)
  const [currentStep, setCurrentStep] = useState(0)
  const [feedbacksPerType, setFeedbacksPerType] = useState({})
  const [loading, setLoading] = useState(false)

  const feedbacks = feedbacksPerType[currentFeedbackType] || feedbackQuestions.map(q => ({ id: q.id, score: '', comments: '' }))

  const updateFeedback = (index, field, value) => {
    const newFeedbacks = [...feedbacks]
    newFeedbacks[index][field] = value
    setFeedbacksPerType({ ...feedbacksPerType, [currentFeedbackType]: newFeedbacks })
  }

  const handleFeedbackSubmit = async () => {
    setLoading(true)
    try {
      const feedbackList = feedbacks.filter(f => Number(f.score) >= 1).map(feedback => {
        const question = feedbackQuestions.find(q => q.id === feedback.id)
        return {
          question_id: feedback.id,
          score: Number(feedback.score),
          comments: feedback.comments || null
        }
      })
      
      const payload = {
        client_id: person.id,
        assessment_id: arDetail.id,
        recommendation_type: currentFeedbackType,
        feedbacks: feedbackList
      }

      await submitAIRecommendationFeedback(payload)
      message.success('Feedback submitted successfully!')
      closeModal()
      setFeedbacksPerType({ ...feedbacksPerType, [currentFeedbackType]: feedbackQuestions.map(q => ({ id: q.id, score: '', comments: '' })) })
      setCurrentStep(0)
    } catch (error) {
      message.error('Failed to submit feedback. Please try again.')
      console.error('Error submitting feedback:', error)
    } finally {
      setLoading(false)
    }
  }

  const openModal = (type) => {
    setCurrentFeedbackType(type)
    const questions = getFeedbackQuestions(type)
    setFeedbackQuestions(questions)
    setShowFeedbackModal(true)
  }

  const closeModal = () => {
    setShowFeedbackModal(false)
  }

  const nextStep = () => {
    setCurrentStep(currentStep + 1)
  }

  const prevStep = () => {
    setCurrentStep(currentStep - 1)
  }

  return {
    feedbackQuestions,
    showFeedbackModal,
    currentFeedbackType,
    currentStep,
    setCurrentStep,
    feedbacks,
    updateFeedback,
    loading,
    handleFeedbackSubmit,
    openModal,
    closeModal,
    nextStep,
    prevStep
  }
}

export const getRecommendationDisplayName = (type) => {
  return `${type} recommendations`
}
